/* ---- CC shared cart state (Sep 29 2026) ----------------------------------
 * The same block sits at the top of cc-fast-cart.js, cc-delivery.js and
 * cc-gift.js; whichever loads first installs it, the others reuse it.
 *   - ONE /cart.js download shared by every cart script (no duplicates).
 *   - Carts returned by /cart/change|update|clear are reused, not re-downloaded.
 *   - Any cart write marks the copy stale, so nobody ever reads an old cart.
 *   - preview(): the cart as the customer expects it right now (taps not yet
 *     saved). Used ONLY to repaint numbers instantly; never to act on.
 * ------------------------------------------------------------------------ */
(function () {
  if (window.ccCart) { return; }
  var nf = window.fetch;
  if (!nf) { return; }
  var MUT = /\/cart\/(add|change|update|clear)/;
  var last = null, lastAt = 0, stale = true, pending = 0, ver = 0, inflight = null;
  var subs = [], psubs = [];

  function isCart(c) { return c && c.items && typeof c.total_price === 'number'; }
  function emit(list, c) { list.forEach(function (fn) { try { fn(c); } catch (e) {} }); }

  function set(c) {
    if (!isCart(c)) { return; }
    last = c; lastAt = Date.now();
    if (pending === 0) { stale = false; }
    emit(subs, c);
  }

  function get(maxAge) {
    if (!stale && pending === 0 && last && maxAge && Date.now() - lastAt < maxAge) {
      return Promise.resolve(last);
    }
    if (inflight) { return inflight; }
    var v = ver;
    inflight = nf.call(window, '/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inflight = null;
        if (v === ver && pending === 0) { set(c); }
        return c;
      }, function (e) { inflight = null; throw e; });
    return inflight;
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : ((input && input.url) || '');
    var mut = MUT.test(url);
    if (mut) { ver++; pending++; stale = true; }
    var p = nf.apply(window, arguments);
    if (mut) {
      p.then(function (r) {
        pending = Math.max(0, pending - 1);
        if (!r.ok || /\/cart\/add/.test(url)) { stale = true; return; }
        var ct = (r.headers && r.headers.get('content-type')) || '';
        if (ct.indexOf('json') === -1) { stale = true; return; }
        r.clone().json().then(set).catch(function () { stale = true; });
      }, function () { pending = Math.max(0, pending - 1); stale = true; });
    }
    return p;
  };

  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && MUT.test(u)) {
      ver++; pending++; stale = true;
      this.addEventListener('loadend', function () { pending = Math.max(0, pending - 1); stale = true; });
    }
    return xo.apply(this, arguments);
  };

  window.ccCart = {
    get: get,
    last: function () { return last; },
    /* the cart only if it is known to be current (no write since it arrived) */
    fresh: function () { return (!stale && pending === 0) ? last : null; },
    on: function (fn) { subs.push(fn); },
    onPreview: function (fn) { psubs.push(fn); },
    preview: function (c) { if (isCart(c)) { emit(psubs, c); } }
  };
}());

/*  Classic Ceramics - fast cart quantity (Sep 27 2026)
 *
 *  The theme's own + / - buttons in the cart waited for TWO server trips on
 *  every tap (change the quantity, then download and rebuild the whole cart).
 *  Measured on this store: 2 to 4 seconds per tap.
 *
 *  This script takes over the + / -, the quantity box and the Remove link
 *  inside the cart drawer and the cart page only:
 *    1. The number and the subtotal change on screen immediately.
 *    2. Quick taps are combined: one request is sent 400 ms after the last tap.
 *    3. The full-cart download is skipped unless it is really needed
 *       (an item was removed, or a discount is running).
 *    4. Shopify's answer always wins: the subtotal and count are corrected
 *       from the server's cart, and "not enough stock" errors are shown.
 *    5. If Checkout is pressed while an update is still saving, checkout waits
 *       for it, so the order is placed with the right quantities.
 *
 *  Product-page quantity boxes are not touched.
 */
(function () {
  'use strict';

  if (window.__ccFastCart) { return; }
  window.__ccFastCart = true;

  var FORMS = '#CartDrawerForm, #CartPageForm';
  var WAIT_MS = 300;

  var cart = null;        /* last cart JSON confirmed by Shopify */
  var wanted = {};        /* line key -> quantity the customer wants (not yet confirmed) */
  var timers = {};        /* line key -> pending send timer */
  var inflight = 0;       /* requests on the wire */
  var chain = Promise.resolve();
  var pendingCheckout = null;

  function money(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return 'Rs ' + Math.round(cents / 100).toLocaleString(); }
  }

  /* ---- Sep 29: stock limit ------------------------------------------------
     snippets/cart-item.liquid puts the stock on each box (data-max). The +
     stops there and a small note says "Only N left in stock" instead of a
     pop-up. Items that keep selling when out of stock have no data-max. */
  (function () {
    if (document.getElementById('CCStockStyle')) { return; }
    var s = document.createElement('style');
    s.id = 'CCStockStyle';
    s.textContent =
      '.js-qty__adjust--plus.cc-at-max{opacity:.3;}' +
      '.cc-stock-note{font-size:12px;line-height:1.4;color:#b3261e;font-weight:600;margin-top:6px;}' +
      '.cc-stock-note[hidden]{display:none!important;}';
    (document.head || document.documentElement).appendChild(s);
  }());

  function maxOf(input) {
    var m = parseInt(input && input.dataset ? input.dataset.max : '', 10);
    return isNaN(m) ? null : m;
  }

  function noteFor(input) {
    var wrap = input.closest('.js-qty__wrapper');
    if (!wrap || !wrap.parentNode) { return null; }
    var n = wrap.nextElementSibling;
    if (!n || !n.classList.contains('cc-stock-note')) {
      n = document.createElement('div');
      n.className = 'cc-stock-note';
      n.hidden = true;
      wrap.parentNode.insertBefore(n, wrap.nextSibling);
    }
    return n;
  }

  function stockText(max) { return max <= 0 ? 'Out of stock' : 'Only ' + max + ' left in stock'; }

  /* Fade the + and show / hide the note to match the number in the box. */
  function refreshLimit(input) {
    var max = maxOf(input);
    if (max === null) { return; }
    var q = parseInt(input.value, 10) || 0;
    var at = q >= max;
    var wrap = input.closest('.js-qty__wrapper');
    var plus = wrap && wrap.querySelector('.js-qty__adjust--plus');
    if (plus) { plus.classList.toggle('cc-at-max', at); }
    var n = noteFor(input);
    if (n) { n.textContent = stockText(max); n.hidden = !at; }
  }

  function showNote(key, text) {
    var input = document.querySelector('.js-qty__num[data-id="' + key + '"]');
    if (!input) { return; }
    var n = noteFor(input);
    if (n) { n.textContent = text; n.hidden = false; }
  }

  function inCart(el) { return el && el.closest ? el.closest(FORMS) : null; }
  function hasTimers() { return Object.keys(timers).length > 0; }
  function busy() { return inflight > 0 || hasTimers(); }

  function loadCart() {
    var p = window.ccCart ? window.ccCart.get(0) :
      fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return p.then(function (c) { cart = c; return c; });
  }

  /* Sep 29: tell the delivery / gift / total boxes what the cart WILL be,
     so they repaint on the tap instead of after Shopify answers. */
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function previewCart() {
    if (!cart || !cart.items || !window.ccCart) { return; }
    if (!Object.keys(wanted).length) { return; }
    var c = JSON.parse(JSON.stringify(cart));
    var total = 0, count = 0;
    c.items = c.items.filter(function (it) {
      var q = has(wanted, it.key) ? wanted[it.key] : it.quantity;
      it.quantity = q;
      it.line_price = it.price * q;
      it.final_line_price = it.final_price * q;
      total += it.final_line_price;
      count += q;
      return q > 0;
    });
    c.total_price = total;
    c.items_subtotal_price = total;
    c.item_count = count;
    c.__preview = true;
    window.ccCart.preview(c);
  }
  if (window.ccCart) {
    window.ccCart.on(function (c) {
      cart = c;
      /* a saved answer arrived while other taps are still waiting:
         put the customer's expected numbers back on screen */
      Promise.resolve().then(function () {
        if (Object.keys(wanted).length) { paintLocal(); previewCart(); }
      });
    });
  }

  function knows(key) {
    return !!(cart && cart.items && cart.items.some(function (i) { return i.key === key; }));
  }

  /* Subtotal and item count as the customer expects them right now. */
  function localTotals() {
    if (!cart || !cart.items) { return null; }
    var total = 0, count = 0;
    cart.items.forEach(function (it) {
      var q = Object.prototype.hasOwnProperty.call(wanted, it.key) ? wanted[it.key] : it.quantity;
      total += it.final_price * q;
      count += q;
    });
    return { total: total, count: count };
  }

  function paint(total, count) {
    document.querySelectorAll(FORMS).forEach(function (f) {
      var s = f.querySelector('[data-subtotal]');
      if (s) { s.innerHTML = money(total); }
    });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.innerText = count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function paintLocal() {
    var t = localTotals();
    if (t) { paint(t.total, t.count); }
  }

  /* Put confirmed quantities back into boxes that have nothing pending. */
  function syncFromCart() {
    if (!cart) { return; }
    document.querySelectorAll(FORMS).forEach(function (f) {
      f.querySelectorAll('.js-qty__num[data-id]').forEach(function (input) {
        var key = input.dataset.id;
        if (Object.prototype.hasOwnProperty.call(wanted, key)) { return; }
        var it = cart.items.find(function (i) { return i.key === key; });
        if (it) {
          input.value = it.quantity;
          refreshLimit(input);
          var row = input.closest('.cart__item');
          if (row) { row.style.opacity = ''; }
        }
      });
    });
    if (Object.keys(wanted).length) { paintLocal(); } else { paint(cart.total_price, cart.item_count); }
  }

  /* Let the theme redraw the cart from Shopify (used only when needed). */
  function rebuild() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function setQty(input, qty) {
    var key = input.dataset.id;
    if (!key) { return; }
    qty = Math.max(0, parseInt(qty, 10) || 0);
    var maxQ = maxOf(input);
    if (maxQ !== null && qty > maxQ) { qty = maxQ; }

    input.value = qty;
    wanted[key] = qty;
    refreshLimit(input);

    var row = input.closest('.cart__item');
    if (row) {
      row.style.transition = 'opacity .2s';
      row.style.opacity = qty === 0 ? '.35' : '';
    }

    if (knows(key)) { paintLocal(); previewCart(); }
    else { loadCart().then(function () { paintLocal(); previewCart(); }).catch(function () {}); }

    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      delete timers[key];
      send(key);
    }, qty === 0 ? 0 : WAIT_MS);
  }

  /* Sep 30: the cart as it will be once this quantity is saved (plus any
     other taps still waiting) - used to work out the gift change up front. */
  function cartWith(key, qty) {
    if (!cart || !cart.items) { return null; }
    var c = JSON.parse(JSON.stringify(cart));
    c.items = c.items.filter(function (it) {
      var q = it.key === key ? qty : (has(wanted, it.key) ? wanted[it.key] : it.quantity);
      it.quantity = q;
      it.line_price = it.price * q;
      it.final_line_price = it.final_price * q;
      return q > 0;
    });
    c.item_count = c.items.reduce(function (a, it) { return a + it.quantity; }, 0);
    return c;
  }

  function send(key) {
    if (!Object.prototype.hasOwnProperty.call(wanted, key)) { return; }
    var qty = wanted[key];
    inflight++;

    chain = chain.then(function () {
      /* Sep 30: if this change crosses a gift level (Rs 5,000 / 10,000),
         add / swap / remove the gift in the SAME request - one round trip
         instead of two. Otherwise the usual single-line change. */
      var gp = null;
      try { gp = window.ccGift && window.ccGift.plan ? window.ccGift.plan(cartWith(key, qty)) : null; } catch (e) { gp = null; }
      var url = '/cart/change.js?t=' + Date.now();
      var payload = { id: key, quantity: qty };
      if (gp) {
        var ups = {};
        ups[key] = qty;
        Object.keys(gp).forEach(function (k) { ups[k] = gp[k]; });
        url = '/cart/update.js?t=' + Date.now();
        payload = { updates: ups };
        try { window.ccGift.ours(); } catch (e) {}
      }
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (wanted[key] === qty) { delete wanted[key]; }

          if (!res.ok || res.j.status) {
            /* e.g. 422: not enough stock. Redraw from the real cart and say so
               quietly under the item (Sep 29: no more browser pop-up). Errors
               that are not about stock - e.g. the line changed underneath us -
               are simply fixed by the redraw, with no message. */
            var msg = res.j.description || res.j.message || '';
            var aboutStock = /stock|available|availability|only \d|sold out/i.test(msg);
            return loadCart().then(function () {
              rebuild();
              syncFromCart();
              if (aboutStock) {
                var it = cart && cart.items && cart.items.find(function (i) { return i.key === key; });
                var txt = it ? 'Only ' + it.quantity + ' left in stock' : 'Sorry, this item just sold out';
                showNote(key, txt);
                /* the theme redraws the cart a moment later - show it again after that */
                window.setTimeout(function () { showNote(key, txt); }, 1500);
              }
            });
          }

          cart = res.j;
          /* Sep 30: last item removed on the cart page - show the theme's own
             "Your cart is currently empty" page instead of a Rs 0 totals box. */
          if (cart.item_count === 0 && !Object.keys(wanted).length && document.getElementById('CartPageForm')) {
            window.location.reload();
            return;
          }
          var removed = !cart.items.some(function (i) { return i.key === key; });
          var hasDiscount = (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) ||
                            cart.total_discount > 0;

          if ((removed || hasDiscount || gp) && !Object.keys(wanted).length) { rebuild(); }
          syncFromCart();
          previewCart();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });
    })
      .catch(function () {
        if (wanted[key] === qty) { delete wanted[key]; }
        return loadCart().then(function () { rebuild(); syncFromCart(); }).catch(function () {});
      })
      .then(function () {
        inflight--;
        finishCheckout();
      });
  }

  /* ---- taps: + / - and Remove (capture phase, so the theme's slow handler never runs) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }

    var btn = t.closest('.js-qty__adjust');
    if (btn && inCart(btn)) {
      var wrap = btn.closest('.js-qty__wrapper');
      var input = wrap && wrap.querySelector('.js-qty__num[data-id]');
      if (!input) { return; }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var cur = parseInt(input.value, 10);
      if (isNaN(cur)) { cur = 1; }
      var isPlus = btn.classList.contains('js-qty__adjust--plus');
      var maxT = maxOf(input);
      if (isPlus && maxT !== null && cur >= maxT) {
        /* at the stock limit: nothing is sent, the note explains why */
        refreshLimit(input);
        var nt = noteFor(input);
        if (nt) { nt.hidden = false; }
        return;
      }
      setQty(input, isPlus ? cur + 1 : cur - 1);
      return;
    }

    var rm = t.closest('.cart__remove a');
    if (rm && inCart(rm)) {
      var item = rm.closest('.cart__item');
      var inp = item && item.querySelector('.js-qty__num[data-id]');
      if (!inp) { return; }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setQty(inp, 0);
    }
  }, true);

  /* ---- typing a number into the box ---- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('js-qty__num')) { return; }
    if (!input.dataset.id || !inCart(input)) { return; }
    e.stopPropagation();
    e.stopImmediatePropagation();
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) { q = 1; }
    setQty(input, q);
  }, true);

  /* ---- Checkout pressed while an update is still saving: wait for it ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORMS)) { return; }
    if (!busy()) { return; }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var btn = e.submitter || form.querySelector('.cart__checkout');
    if (btn) { btn.classList.add('btn--loading'); }
    pendingCheckout = { form: form, btn: btn };
    Object.keys(timers).forEach(function (k) {
      clearTimeout(timers[k]);
      delete timers[k];
      send(k);
    });
    finishCheckout();
  }, true);

  function finishCheckout() {
    if (!pendingCheckout || busy()) { return; }
    var p = pendingCheckout;
    pendingCheckout = null;
    if (p.btn) { p.btn.classList.remove('btn--loading'); }
    if (p.form.requestSubmit) {
      p.form.requestSubmit(p.btn && p.btn.name === 'checkout' ? p.btn : undefined);
    } else {
      p.form.submit();
    }
  }

  /* ---- keep the local copy of the cart fresh ---- */
  document.addEventListener('ajaxProduct:added', function () { loadCart().catch(function () {}); });
  window.addEventListener('pageshow', function () { loadCart().catch(function () {}); });
  loadCart().catch(function () {});
}());
